export { default } from './Legend';
